import React from "react";
import { embedConverter } from "../embed-converter";
import { EmbedViewer } from "../viewer/embed-viewer";
const Embed = ({ settings, node }) => {
  const ricosNode = React.useMemo(() => embedConverter.fromPm.convert(node.toJSON()), [node]);
  return /* @__PURE__ */ React.createElement(
    EmbedViewer,
    {
      node: ricosNode,
      settings,
      iframeSandboxDomain: ""
    }
  );
};
export {
  Embed
};
//# sourceMappingURL=embed.js.map
